export const GUARD_STORAGE_TTL_MS = 5 * 60 * 1000;
export const QUICK_CHECK_INTERVAL_MS = 15 * 1000;
export const MODERATE_CHECK_INTERVAL_MS = 60 * 1000;
export const INCIDENT_CORRECTION_WINDOW_SECONDS = 20;
export const FOCUS_LOST_LIMIT = 5;
export const FOCUS_LOST_DEBOUNCE_MS = 1500;
export const INITIAL_CAMERA_GRACE_PERIOD_MS = 8000;

export const CRITICAL_CHECK_IDS = new Set([
  'monitor_count',
  'webcam_virtual',
  'camera_stream',
  'browser_focus',
  'monitoring_liveness',
  'screen_share',
  'screen_share_active',
]);
